class CommunityForm extends HTMLElement {
  connectedCallback() {
    this.introEl = this.querySelector('.community-form__intro');
    this.formEl = this.querySelector('[data-form]');
    this.successEl = this.querySelector('[data-success-state]');
    this.submitButton = this.querySelector('[data-submit-button]');
    this.submitLabel = this.submitButton.querySelector('[data-label]');
    this.genericError = this.querySelector('[data-generic-error]');
    this.resetButton = this.querySelector('[data-reset-button]');

    this.formEl.addEventListener('submit', this.onSubmit.bind(this));
    if (this.resetButton) {
      this.resetButton.addEventListener('click', this.onReset.bind(this));
    }
  }

  clearErrors() {
    this.querySelectorAll('[data-error-for]').forEach((el) => {
      el.textContent = '';
    });
    this.genericError.hidden = true;
  }

  onReset() {
    this.successEl.hidden = true;
    this.introEl.hidden = false;
    this.formEl.hidden = false;
  }

  async onSubmit(event) {
    event.preventDefault();
    this.clearErrors();

    const formData = new FormData(this.formEl);
    const payload = {
      name: formData.get('name') || '',
      email: formData.get('email') || '',
      phone: formData.get('phone') || '',
      sizes: formData.get('sizes') || '',
      stage: formData.get('stage') || '',
      acceptsMarketing: formData.get('acceptsMarketing') === 'on',
      website: formData.get('website') || '',
      source_page: window.location.href,
    };

    const originalLabel = this.submitLabel.textContent;
    this.submitButton.disabled = true;
    if (this.dataset.sendingLabel) this.submitLabel.textContent = this.dataset.sendingLabel;

    try {
      const response = await fetch('/apps/integrations/community', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await response.json();

      if (data.ok) {
        // Meta Pixel: Lead event (Comunidad.tsx real, mismos parámetros) —
        // enviado server-side vía Conversions API desde el Worker (ver
        // src/lib/metaCapi.js en pomkids-worker), no desde el navegador.
        // Un Custom Pixel de Admin no es viable (sandbox sin acceso a fbq),
        // y el Web Pixel nativo de Meta no escucha eventos custom del theme.
        this.formEl.reset();
        this.introEl.hidden = true;
        this.formEl.hidden = true;
        this.successEl.hidden = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (data.errors) {
        Object.entries(data.errors).forEach(([field, message]) => {
          const el = this.querySelector(`[data-error-for="${field}"]`);
          if (el) el.textContent = message;
        });
      } else {
        this.genericError.hidden = false;
      }
    } catch (error) {
      this.genericError.hidden = false;
    } finally {
      this.submitButton.disabled = false;
      this.submitLabel.textContent = originalLabel;
    }
  }
}

customElements.define('community-form', CommunityForm);
